import type {PartnerHostInfo} from './partner-host'

const PUBLIC_TENANT_ENTRY_PATHS = new Set([
    '/',
    '/indywidualne',
    '/wydarzenia',
    '/kursy',
    '/o-studiu',
    '/cennik',
    '/regulamin',
    '/polityka-prywatnosci',
])
export const PUBLIC_TENANT_ENTRY_HEADER = 'x-fitro-public-tenant-entry'

export function isPublicTenantEntryPath(pathname: string): boolean {
    if (PUBLIC_TENANT_ENTRY_PATHS.has(pathname)) return true
    return /^\/(?:zajecia|wydarzenia|kursy)\/[^/]+$/.test(pathname)
}

// Only these pages of a studio the backend reports as `seoIndexable` are offered to search engines; everything else
// stays noindex.
export const INDEXABLE_TENANT_PATHS = ['/', '/o-studiu', '/cennik', '/indywidualne', '/wydarzenia', '/kursy'] as const
export type IndexableTenantPath = (typeof INDEXABLE_TENANT_PATHS)[number]

export function isIndexableTenantPath(pathname: string): pathname is IndexableTenantPath {
    return (INDEXABLE_TENANT_PATHS as readonly string[]).includes(pathname)
}

// The production host of a studio; dev and localhost are never indexed.
export function isProductionStudioHost(hostInfo: PartnerHostInfo): boolean {
    return hostInfo.kind === 'canonical' && hostInfo.zone === 'fitro' && Boolean(hostInfo.slug)
}

// A public studio page on its production host whose robots meta decides; every other request carries a blanket noindex
// header. A query string never reaches the index, so it keeps the header too.
export function leavesRobotsToPage(hostInfo: PartnerHostInfo, pathname: string, search: string): boolean {
    return isProductionStudioHost(hostInfo) && isPublicTenantEntryPath(pathname) && search === ''
}
